import { BRAND } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

const WHATSAPP_NUMBER = BRAND.phoneHref.replace(/[^\d]/g, "");

export const WhatsAppButton = () => {
  const { t } = useLang();
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t.whatsapp.message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label={t.whatsapp.label}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
    >
      <span className="hidden md:block max-w-0 overflow-hidden whitespace-nowrap rounded-full bg-[#0A0A0C]/90 text-[#FDFBF7] text-sm px-0 py-2.5 border border-[#C5A059]/30 opacity-0 transition-all duration-500 group-hover:max-w-xs group-hover:px-5 group-hover:opacity-100">
        {t.whatsapp.label}
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg shadow-black/40 transition-transform duration-300 group-hover:scale-110">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <svg viewBox="0 0 32 32" className="relative h-7 w-7 fill-white" aria-hidden="true">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.048 9.38L1.052 31.3l6.128-1.96A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.312 22.594c-.386 1.09-1.92 1.994-3.142 2.258-.836.178-1.928.32-5.604-1.204-4.702-1.948-7.73-6.726-7.966-7.036-.226-.31-1.9-2.53-1.9-4.826 0-2.296 1.204-3.424 1.63-3.89.352-.386.768-.56 1.204-.56.14 0 .266.008.38.012.342.014.514.034.74.574.282.676.966 2.36 1.048 2.532.082.172.138.374.022.584-.108.21-.206.34-.378.544-.172.204-.364.456-.52.612-.172.172-.35.358-.15.702.2.344.888 1.464 1.906 2.372 1.312 1.17 2.4 1.54 2.792 1.714.344.152.544.128.744-.078.252-.26 1.07-1.248 1.354-1.676.282-.428.566-.356.942-.214.378.14 2.396 1.13 2.808 1.336.412.206.686.308.788.48.1.172.1.99-.286 2.08z" />
        </svg>
      </span>
    </a>
  );
};
